// @ts-nocheck
export class SimpleControl {
  constructor(onClick, icon) {
    this._container = document.createElement('div');

    this._container.style.backgroundColor = '#fff';
    this._container.style.borderRadius = '2px';
    this._container.style.boxShadow = 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px';
    this._container.style.userSelect = 'none';
    this._container.style.margin = '8px 0 0 16px';
    this._container.style.padding = '7px 7px 5px';
    this._container.style.cursor = 'pointer';

    this._container.addEventListener('click', onClick);

    this._link = document.createElement('a');
    this._link.href = '#';
    this._link.innerHTML = icon;

    this._link.addEventListener('click', (event) => event.preventDefault());

    this._container.appendChild(this._link);
  }

  get element() {
    return this._container;
  }

  setIcon(icon) {
    this._link.innerHTML = icon;
  }
}

export class ZoomInControl extends SimpleControl {
  constructor(onClick) {
    super(onClick, ZoomInControl.icon);
  }
}

export class ZoomOutControl extends SimpleControl {
  constructor(onClick) {
    super(onClick, ZoomOutControl.icon);
    this._container.style.marginTop = '0';
  }
}

export class LayersControl extends SimpleControl {
  constructor(onClick) {
    super(onClick, LayersControl.icon);
  }
}

export class ExtentsControl extends SimpleControl {
  constructor(onClick) {
    super(onClick, ExtentsControl.icon);
  }
}

export class LocateControl extends SimpleControl {
  constructor(onClick) {
    super(onClick, LocateControl.icon);
  }
}

ZoomInControl.icon = `
<svg id="ZoomInControl" width="18" height="18" viewBox="-2 -2 14 14" xmlns="http://www.w3.org/2000/svg">
  <path stroke="#666" fill="#666" d="M9 4H6V1C6 0.45 5.55 0 5 0C4.45 0 4 0.45 4 1V4H1C0.45 4 0 4.45 0 5C0 5.55 0.45 6 1 6H4V9C4 9.55 4.45 10 5 10C5.55 10 6 9.55 6 9V6H9C9.55 6 10 5.55 10 5C10 4.45 9.55 4 9 4Z" />
</svg>
`;

ZoomOutControl.icon = `
<svg id="ZoomOutControl" width="18" height="18" viewBox="-2 -2 14 14" xmlns="http://www.w3.org/2000/svg">
<path stroke="#666" fill="#666" d="M9,4H4H3H1C0.5,4,0,4.5,0,5s0.5,1,1,1h2h1h5c0.5,0,1-0.5,1-1S9.5,4,9,4z"/>
</svg>
`;

LayersControl.icon = `
<svg id="LayersControl" xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 100 100">
  <path stroke="#666" fill="#666" d="M95 27.5c0-1-.6-1.8-1.4-2.3l-42.5-20c-.7-.3-1.5-.3-2.1 0l-42.5 20c-.9.5-1.5 1.3-1.5 2.3s.6 1.8 1.4 2.3l19.1 9-19.1 9C5.6 48.2 5 49 5 50s.6 1.8 1.4 2.3l19.1 9-19.1 9c-.8.4-1.4 1.2-1.4 2.2s.6 1.8 1.4 2.3l42.5 20c.3.2.7.2 1.1.2s.7-.1 1.1-.2l42.5-20c.9-.4 1.4-1.3 1.4-2.3s-.6-1.8-1.4-2.3l-19.1-9 19.1-9c.8-.4 1.4-1.2 1.4-2.2s-.6-1.8-1.4-2.3l-19.1-9 19.1-9c.8-.4 1.4-1.2 1.4-2.2zM50 89.7L13.4 72.5l18-8.5 17.5 8.2c.3.2.7.2 1.1.2s.7-.1 1.1-.2L68.6 64l18 8.5L50 89.7zm0-22.5L13.4 50l18-8.5 17.5 8.2c.3.2.7.2 1.1.2s.7-.1 1.1-.2l17.5-8.2 18 8.5L50 67.2zm0-22.5L13.4 27.5 50 10.3l36.6 17.2L50 44.7z"/>
</svg>
`;

ExtentsControl.icon = `
<svg id="ExtentsControl" width="18" height="18" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path fill="#666666" d="M49.8753 16C30.5915 16 14.9626 31.668 14.9626 51C14.9626 70.332 30.5915 86 49.8753 86C69.1591 86 84.788 70.332 84.788 51C84.788 31.668 69.1591 16 49.8753 16ZM49.8753 81.625C48.2388 81.625 46.6022 81.4883 45.0203 81.2422C43.6019 79.7383 42.2654 77.5781 41.0926 74.8711C40.0561 72.4922 39.1833 69.8125 38.5287 66.9141C42.1291 66.5039 45.9749 66.3125 49.9026 66.3125C53.8575 66.3125 57.6761 66.5312 61.2765 66.9141C60.5946 69.8125 59.7491 72.4922 58.7126 74.8711C57.5397 77.5781 56.2032 79.7109 54.7849 81.2422C53.1484 81.4883 51.5118 81.625 49.8753 81.625ZM49.8753 64.125C45.7294 64.125 41.7472 64.3438 38.0377 64.7812C37.274 60.8438 36.8376 56.5508 36.783 52.0938H62.9676C62.913 56.5508 62.4766 60.8164 61.7129 64.7812C58.0034 64.3438 54.0212 64.125 49.8753 64.125ZM49.8753 20.375C51.5118 20.375 53.1484 20.5117 54.7304 20.7578C56.1487 22.2617 57.4852 24.4219 58.658 27.1289C59.6945 29.5078 60.5673 32.1875 61.2219 35.0859C57.6488 35.4688 53.8303 35.6875 49.8753 35.6875C45.9204 35.6875 42.1018 35.4688 38.5014 35.0859C39.1833 32.1875 40.0288 29.5078 41.0653 27.1289C42.2382 24.4219 43.5747 22.2891 44.993 20.7578C46.6022 20.5117 48.2388 20.375 49.8753 20.375ZM49.8753 37.875C54.0212 37.875 58.0034 37.6562 61.7129 37.2188C62.4766 41.1562 62.913 45.4492 62.9676 49.9062H36.783C36.8376 45.4492 37.274 41.1836 38.0377 37.2188C41.7472 37.6562 45.7294 37.875 49.8753 37.875ZM65.1496 49.9062C65.0951 45.3125 64.6314 40.9375 63.8677 36.9453C68.3136 36.3438 72.2685 35.4414 75.5143 34.3203C78.5147 38.9414 80.2057 44.2734 80.3967 49.8789H65.1496V49.9062ZM34.601 49.9062H19.3267C19.5449 44.3008 21.236 38.9688 24.2363 34.3477C27.4821 35.4414 31.437 36.3438 35.8829 36.9727C35.1192 40.9375 34.6828 45.3125 34.601 49.9062ZM34.601 52.0938C34.6555 56.6875 35.1192 61.0625 35.8829 65.0547C31.437 65.6562 27.4821 66.5586 24.2363 67.6797C21.236 63.0312 19.5449 57.6992 19.354 52.0938H34.601ZM65.1496 52.0938H80.4239C80.233 57.6992 78.5419 63.0312 75.5416 67.6523C72.2958 66.5586 68.3409 65.6562 63.895 65.0273C64.6314 61.0625 65.0678 56.6875 65.1496 52.0938ZM74.2051 32.4609C74.096 32.4883 73.9869 32.543 73.8778 32.5703C70.8229 33.5273 67.2771 34.2656 63.4313 34.8125C62.2039 29.3711 60.3491 24.7773 58.1125 21.4961C63.1312 22.8906 67.7135 25.5703 71.5048 29.3438C72.4595 30.3281 73.3596 31.3672 74.2051 32.4609ZM41.6654 21.4961C39.4288 24.7773 37.574 29.3711 36.3466 34.8125C32.5008 34.293 28.955 33.5273 25.9001 32.5703C25.791 32.543 25.6819 32.4883 25.5728 32.4609C26.4183 31.3672 27.3184 30.3281 28.3003 29.3438C32.0644 25.5703 36.6467 22.8906 41.6654 21.4961ZM25.5455 69.5391C25.6546 69.5117 25.7637 69.457 25.8728 69.4297C28.9277 68.4727 32.4735 67.7344 36.3194 67.1875C37.5468 72.6289 39.4015 77.2227 41.6381 80.5039C36.6194 79.1094 32.0371 76.4297 28.2458 72.6562C27.2911 71.6719 26.3911 70.6328 25.5455 69.5391ZM58.0853 80.5039C60.3219 77.2227 62.1766 72.6289 63.404 67.1875C67.2498 67.707 70.7957 68.4727 73.8505 69.4297C73.9596 69.457 74.0687 69.5117 74.1778 69.5391C73.3323 70.6328 72.4322 71.6719 71.4503 72.6562C67.6863 76.4297 63.104 79.1094 58.0853 80.5039Z"/>
  <path fill="#666666" d="M99.7506 30.5L69.8254 0H99.7506V30.5Z"/>
  <path fill="#666666" d="M69.5761 100L100 70V100H69.5761Z"/>
  <path fill="#666666" d="M0.249379 69.5L30.1746 100H0.249377L0.249379 69.5Z"/>
  <path fill="#666666" d="M30.4239 3.99959e-06L0 30L3.92421e-06 0L30.4239 3.99959e-06Z"/>
</svg>
`;

LocateControl.icon = `
<svg id="LocateControl" xmlns="http://www.w3.org/2000/svg" viewBox="10 10 44 44" width="18">
  <path stroke="#666" fill="#666" d="M52,30h-2.118C48.956,21.671,42.329,15.044,34,14.118V12c0-1.104-0.896-2-2-2s-2,0.896-2,2v2.118   C21.671,15.044,15.044,21.671,14.118,30H12c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.118C15.044,42.329,21.671,48.956,30,49.882V52   c0,1.104,0.896,2,2,2s2-0.896,2-2v-2.118C42.328,48.956,48.956,42.328,49.882,34H52c1.104,0,2-0.896,2-2S53.104,30,52,30z    M34,45.84V44c0-1.104-0.896-2-2-2s-2,0.896-2,2v1.84C23.882,44.959,19.041,40.118,18.16,34H20c1.104,0,2-0.896,2-2s-0.896-2-2-2   h-1.84c0.881-6.118,5.722-10.959,11.84-11.84V20c0,1.104,0.896,2,2,2s2-0.896,2-2v-1.84c6.118,0.881,10.959,5.722,11.84,11.84H44   c-1.104,0-2,0.896-2,2s0.896,2,2,2h1.84C44.959,40.118,40.118,44.959,34,45.84z"/>
</svg>
`;

LocateControl.iconActive = `
<svg id="LocateControlActive" xmlns="http://www.w3.org/2000/svg" viewBox="10 10 44 44" width="18">
  <path stroke="#4285F4" fill="#4285F4" d="M52,30h-2.118C48.956,21.671,42.329,15.044,34,14.118V12c0-1.104-0.896-2-2-2s-2,0.896-2,2v2.118   C21.671,15.044,15.044,21.671,14.118,30H12c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.118C15.044,42.329,21.671,48.956,30,49.882V52   c0,1.104,0.896,2,2,2s2-0.896,2-2v-2.118C42.328,48.956,48.956,42.328,49.882,34H52c1.104,0,2-0.896,2-2S53.104,30,52,30z    M34,45.84V44c0-1.104-0.896-2-2-2s-2,0.896-2,2v1.84C23.882,44.959,19.041,40.118,18.16,34H20c1.104,0,2-0.896,2-2s-0.896-2-2-2   h-1.84c0.881-6.118,5.722-10.959,11.84-11.84V20c0,1.104,0.896,2,2,2s2-0.896,2-2v-1.84c6.118,0.881,10.959,5.722,11.84,11.84H44   c-1.104,0-2,0.896-2,2s0.896,2,2,2h1.84C44.959,40.118,40.118,44.959,34,45.84z"/>
</svg>
`;
